var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTecSolLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #333;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1200,
    height: 1200
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m887.13,313.4v446.41H312.87v-446.41h574.25m62.87-62.87H250v572.16h700V250.52h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 710.85,
    y: 381.73,
    width: 62.87,
    height: 207.49,
    transform: "translate(-125.87 667.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 638.55,
    y: 556.29,
    width: 207.49,
    height: 62.87,
    transform: "translate(-198.18 697.02) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 426.27,
    y: 483.99,
    width: 62.87,
    height: 207.49,
    transform: "translate(-281.53 495.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 353.97,
    y: 454.04,
    width: 207.49,
    height: 62.87,
    transform: "translate(-209.22 465.84) rotate(-45)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 504.64,
    y: 823.73,
    width: 190.72,
    height: 62.87
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "838.92 886.6 361.08 886.6 301.11 949.48 898.89 949.48 838.92 886.6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTecSolLogo);
export default __webpack_public_path__ + "static/media/tecSolLogo.8457cb548bcd35bb2b571c691c703dfe.svg";
export { ForwardRef as ReactComponent };